var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeaser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 321,
    viewBox: "0 0 428 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 165.5,
    r: 101.5,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.96 123.157C164.491 127.873 164.19 139.836 160.92 140.679C159.616 141.015 156.838 140.192 154.01 138.488L155.785 151.043H145.306L148.913 134.228C146.901 131.867 145.54 128.973 145.767 125.73C146.423 116.386 159.43 118.441 161.96 123.157Z",
    fill: "#B28B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.821 118.021C150.545 115.302 144.839 120.555 144.083 121.42C143.281 122.337 142.747 123.483 142.352 124.648C141.923 125.913 141.658 127.228 141.56 128.568C141.467 129.841 141.458 131.187 141.757 132.433C142.036 133.598 142.633 134.553 143.629 135.16C144.086 135.437 144.577 135.646 145.071 135.837C145.558 136.025 146.046 136.207 146.556 136.313C147.522 136.512 148.634 136.478 149.377 135.71C149.645 135.433 149.94 135.085 150.135 134.747C150.206 134.625 150.248 134.545 150.163 134.426C150.06 134.284 149.895 134.175 149.763 134.063C149.014 133.428 148.55 132.58 148.433 131.572C148.314 130.549 148.589 129.229 149.583 128.783C150.811 128.232 152.163 128.864 153.254 129.454C153.717 127.817 154.669 126.344 156.162 125.593C157.813 124.763 159.708 124.666 161.405 123.953C161.847 123.767 162.297 123.557 162.623 123.178C162.759 123.02 162.918 122.815 162.973 122.606C163.044 122.331 162.867 122.101 162.73 121.887C162.005 120.752 160.592 119.057 157.821 118.021Z",
    fill: "#A55728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.742 123.099C149.36 123.099 152.292 120.167 152.292 116.549C152.292 112.932 149.36 110 145.742 110C142.125 110 139.193 112.932 139.193 116.549C139.193 120.167 142.125 123.099 145.742 123.099Z",
    fill: "#A55728"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.403 134.508C142.045 140.086 139.872 143.796 137.884 145.636C138.757 147.484 141.508 148.297 146.138 148.075L148.756 135.823L144.403 134.508Z",
    fill: "#A55728"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.812 187.283L157.806 242.397L165.329 283.778H172.88L165.343 187.283H141.812Z",
    fill: "#B28B67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.812 187.283L157.806 242.397L165.329 283.778H172.88L165.343 187.283H141.812Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.624 187.283C135.74 215.915 135.3 231.531 135.05 234.133C134.801 236.734 133.383 254.156 123.72 284.651H131.573C144.37 255.396 148.837 237.974 150.305 234.133C151.773 230.291 156.107 214.675 162.436 187.283H134.624Z",
    fill: "#B28B67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.469 187.283C145.629 206.248 152.825 236.521 163.056 278.102H174.099C174.915 235.423 171.445 207.333 165.436 187.283H141.469Z",
    fill: "#C7D1D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.568 187.283C135.661 215.915 132.829 244.122 124.055 278.548H135.838C148.658 249.729 157.846 221.661 164.126 187.283H134.568Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.601 290.328L123.034 283.342C125.571 284.084 128.749 283.792 132.567 282.468C136.673 285.376 141.841 287.362 148.072 288.426C148.548 288.507 148.867 288.958 148.786 289.433C148.781 289.464 148.774 289.495 148.766 289.525L148.167 291.637H132.567H123.467L122.601 290.328Z",
    fill: "#191847"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.644 290.328L164.077 283.342C166.614 284.084 169.792 283.792 173.61 282.468C177.716 285.376 182.884 287.362 189.115 288.426C189.591 288.507 189.911 288.958 189.829 289.433C189.824 289.464 189.817 289.495 189.809 289.525L189.21 291.637H173.61H164.51L163.644 290.328Z",
    fill: "#191847"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.355 182.052L134.479 182.088C128.846 200.275 125.804 209.925 125.355 211.038C124.345 213.542 126.483 217.355 127.397 219.405C124.419 220.737 124.736 215.802 120.98 217.55C117.551 219.145 114.943 222.036 110.982 219.591C110.495 219.291 109.961 218.159 111.25 217.275C114.463 215.072 119.093 211.217 119.718 209.948C120.571 208.217 122.45 198.919 125.355 182.052ZM180.255 180.351L192.624 192.417C196.223 193.952 199.172 195.647 201.47 197.502C201.987 198.126 202.55 199.32 200.118 198.786C197.686 198.251 195.103 197.798 194.646 198.589C194.189 199.38 195.536 200.592 194.691 201.627C194.128 202.317 192.234 200.122 189.009 195.042L176.147 187.459L180.255 180.351Z",
    fill: "#B28B67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.285 143.765L155.061 143.118C161.561 159.356 172.91 174.111 189.107 187.382L176.868 202.252C160.672 183.356 150.689 163.86 151.285 143.765Z",
    fill: "#56919C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.826 191.213H168.447C160.658 172.274 156.763 156.186 156.763 142.948L146.621 141.437C138.651 154.256 136.4 170.038 134.826 191.213Z",
    fill: "#C7D1D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.073 141.437C147.865 141.465 149.071 141.514 150.692 141.585L153.143 148.588C153.402 157.126 154.916 174.334 157.684 200.21L135.645 200.21C135.703 201.997 135.798 203.801 135.931 205.622H119.544C121.996 177.967 130.947 156.573 146.399 141.437L146.407 141.445L146.411 141.437H147.073Z",
    fill: "#89C5CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.813 200.382L135.651 200.382C135.382 192.367 135.865 184.687 137.101 177.343C137.729 188.483 139.299 196.163 141.813 200.382Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.551 186.847L151.418 181.795V186.847H140.551Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaser);
export default __webpack_public_path__ + "static/media/teaser.2fdb8074f71825b72e25ebbba3efb549.svg";
export { ForwardRef as ReactComponent };